import React, { useState, useRef } from "react";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import {
  Button,
  CommonErrorMsg,
  InfoIcon,
  ValidateForm,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import { baseURL, post } from "../../Util/axios_helper";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { generateGuid } from "../../Kendo/kendo_common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const EventTips = () => {
  const [error, setError] = useState({});
  const [isAddIcon, setIsAddIcons] = useState(true);

  const [title, setTitle] = useState("");
  const modalRef = useRef(null);
  const [EventTipsList, setEventTipsList] = useState([]);
  const [Loading, setLoading] = useState(false);

  const [EventTips, SetEventTips] = useState({
    EventTipsID: 0,
    DisplayedInID: 0,
    DisplayedInName: "",
    Title: "",
    Description: "",
  });
  const [UpdateEventTips, SetUpdateEventTips] = useState({
    EventTipsID: 0,
    DisplayedInID: 0,
    DisplayedInName: "",
    Title: "",
    Description: "",
    // SortOrder: 0,
    // SavedBy: 0,
  });

  const Parentscolumns = [
    {
      field: "displayedInID",
      filterable: false,
      hidden: true,
    },

    {
      field: "eventName",
      title: "Displayed In",
    },
  ];
  const childColumn = [
    { field: "eventTipsID", hidden: true },
    {
      field: "displayedInID",
      hidden: true,
    },
    { field: "sortOrder", hidden: true },

    {
      field: "displayedInName",
      hidden: true,
    },
    { field: "title", title: "Title" },
    { field: "description", title: "Description" },
  ];

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    SetEventTips({
      EventTipsID: 0,
      DisplayedInID: 0,
      DisplayedInName: "",
      Title: "",
      Description: "",
      // SortOrder: 0,
      // SavedBy: 0,
    });
    setError({});
    setEventTipsList([]);
    setIsAddIcons(true);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const handleEventTipsEditClick = (e) => {
    setTitle(e.child.displayedInName);
    SetUpdateEventTips({
      DisplayedInID: e.parent.displayedInID,
      EventTipsID: e.child.eventTipsID,
      DisplayedInName: e.child.displayedInName,
      Title: e.child.title,
      Description: e.child.description,
    });
    setIsAddIcons(false);
    $("#update_EventTips").modal("show");
  };

  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await corefetch(
        `EventTips/DeleteEventTips?eventTipsID=${e.eventTipsID}`,
        true,
        false,
        true
      );
      refreshChildGrd();
    };
    confirmDelete(onDelete);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (EventTipsList.length == 0) {
      setError({ EmptyList: true });
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        EventTipsList.forEach((eventTips, index) => {
          formData.append(
            `eventTipsModel[${index}].EventTipsID`,
            eventTips.EventTipsID
          );
          formData.append(
            `eventTipsModel[${index}].DisplayedInID`,
            eventTips.DisplayedInID || ""
          );
          formData.append(
            `eventTipsModel[${index}].Title`,
            eventTips.Title || ""
          );
          formData.append(
            `eventTipsModel[${index}].Description`,
            eventTips.Description || ""
          );
        });
        await corepost("EventTips/InsertUpdateEventTips", formData);

        $("#add_EventTips").modal("hide");
        clearForm();
        refreshChildGrd();
      } catch (error) {
        console.error(error);
      }
    }
  };

  const onEditClick = (e) => {
    const eventName = e.eventName;
    setTitle(e.eventName);

    SetEventTips((prevBlog) => ({
      ...prevBlog,
      DisplayedInID: e.displayedInID, 
    }));
    $("#add_EventTips").modal("show");
  };

  const refreshChildGrd = () => {
    $(`#reload-EventTipsTT`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const onRowReorderChange = async (List) => {
    try {
      let EventTipsID = $(List.newRow).find("td").eq(0).text();
      let displayedInId = $(List.newRow).find("td").eq(1).text();
      let oldSortId = $(List.newRow).find("td").eq(2).text();
      let newSortId = $(List.oldRow).find("td").eq(2).text();
      await corefetch(
        `EventTips/SortEventTips?TypeId=${EventTipsID}&newSortId=${newSortId}&oldSortId=${oldSortId}&displayedInId=${displayedInId}`
      );
      refreshChildGrd();
    } catch (error) {
      console.error("Error during row reorder:", error);
    }
  };

  const OnEventTipsAdd = (e) => {
    e.preventDefault();
    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      setError({ EmptyList: false });
      let temp = { ...EventTips, guid: generateGuid() };
      SetEventTips(temp);
      setEventTipsList([...EventTipsList, EventTips]);
      SetEventTips((prev) => ({
        ...prev,
        Title: "",
        Description: "",
      }));
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
    }
  };
  const handleEventTipsAddDeleteClick = (e) => {
    const index = EventTipsList.findIndex((item) => item.guid == e.guid);

    if (index !== -1) {
      const temp = EventTipsList.filter((_, i) => i != index);
      setEventTipsList(temp);
    }
  };
  const onUpdate = async (e) => {
    e.preventDefault();

    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        const eventTips = [UpdateEventTips];

        eventTips.forEach((eventTips, index) => {
          formData.append(
            `eventTipsModel[${index}].EventTipsID`,
            eventTips.EventTipsID
          );
          formData.append(
            `eventTipsModel[${index}].DisplayedInID`,
            eventTips.DisplayedInID || ""
          );
          formData.append(
            `eventTipsModel[${index}].Title`,
            eventTips.Title || ""
          );
          formData.append(
            `eventTipsModel[${index}].Description`,
            eventTips.Description || ""
          );
        });
        await corepost("EventTips/InsertUpdateEventTips", formData);

        $("#update_EventTips").modal("hide");
        clearForm();
        refreshChildGrd();
      } catch (error) {
        console.error(error);
      }
    }
  };
  return (
    <div className="container-fluid">

      <div className="col-auto ms-auto">
        <KendoTreeTable
          name={"EventTipsTT"}
          parentTableColumns={Parentscolumns}
          parentTableUrl={CorebaseURL + "Packages/GetDisplayesInList"}
          childTableUrl={
            CorebaseURL +
            "EventTips/GetEventTipsDetailsById?displayedinID={displayedInID}"
          }
          childTableColumns={childColumn}
          onParentEditClick={onEditClick}
          showParentOptions={true}
          showParentDelete={false}
          showChildOptions={true}
          showChildDelete={true}
          onChildEditClick={handleEventTipsEditClick}
          onChildDeleteClick={handleDeleteClick}
          refreshWhen={EventTipsList.length}
          enableRowReorderable={true}
          onRowReorder={onRowReorderChange}
          noteLabel="Note:"
          noteContent="This module supports drag-and-drop functionality, you can easily
                  rearrange or move data as needed."
        />

        <div
          className="modal custom-modal fade"
          id="add_EventTips"
          role="dialog"
          ref={modalRef}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div
            className="modal-dialog modal-dialog-centered eventTips"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">{title} - Add</h5>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearForm}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form id="event-form" onSubmit={OnEventTipsAdd}>
                  <input
                    type="hidden"
                    name="eventTipsID"
                    value={EventTips.EventTipsID || 0}
                  />
                  <input
                    type="hidden"
                    name="displayedInID"
                    value={EventTips.DisplayedInID || 0}
                  />
                  <div className="row align-items-end">
                    <div className="col-10">
                      <label className="form-label">
                        Title <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Title with a maximum length of 50 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={50}
                        className="form-control"
                        name="Title"
                        value={EventTips.Title || ""}
                        placeholder="Title"
                        data-required="true"
                        onChange={(e) => {
                          SetEventTips((prev) => ({
                            ...prev,
                            Title: e.target.value,
                          }));
                          onValidation("Title", e.target.value);
                        }}
                      />

                      <CommonErrorMsg
                        text="Title is required"
                        IsError={error.Title}
                      />
                    </div>
                  </div>
                  <div className="row align-items-end">
                    <div className="col-10">
                      <div className="input-block">
                        <label className="form-label">
                          Description <span className="text-danger">*</span>
                          <InfoIcon content="Please provide a Description with a maximum length of 300 characters." />
                        </label>
                        <textarea
                          maxLength={300}
                          className="form-control field"
                          name="Description"
                          value={EventTips.Description || ""}
                          placeholder="Description"
                          data-required="true"
                          onChange={(e) => {
                            SetEventTips((prev) => ({
                              ...prev,
                              Description: e.target.value,
                            }));
                            onValidation("Description", e.target.value);
                          }}
                        />
                      </div>
                      <CommonErrorMsg
                        text={
                          error.Description
                            ? "Description is required"
                            : "Please add atleast one Event Tips"
                        }
                        IsError={error.Description || error.EmptyList}
                      />
                    </div>

                    <div className="col-2 mb-4">
                      <button
                        type="submit"
                        className="btn btn-primary mt-2"
                        title="Add Function"
                      >
                        <i
                          className={
                            isAddIcon
                              ? "las la-plus-circle"
                              : "las la-check-circle"
                          }
                        ></i>
                      </button>
                    </div>
                  </div>
                </form>

                <form id="subgrid-form" onSubmit={onSubmit}>
                  {/* {EventTipsList.length > 0 && ( */}
                  <span className="k-form-error k-invalid-msg">
                    (Note: Only the items added to the grid will be saved.)
                  </span>
                  <KendoGrid
                    name={"EventTipsSubGrid"}
                    disableToolbar={true}
                    paggable={true}
                    data={EventTipsList}
                    columns={[
                      {
                        field: "guid",
                        hidden: true,
                      },
                      {
                        field: "EventTipsID",
                        hidden: true,
                      },
                      {
                        field: "DisplayedInID",
                        hidden: true,
                      },
                      {
                        field: "Title",
                        title: "Title ",
                      },
                      {
                        field: "Description",
                        title: "Description",
                      },
                    ]}
                    showOptions={true}
                    showDelete={true}
                    showEdit={false}
                    onDeleteClick={(e) => handleEventTipsAddDeleteClick(e)}
                    refreshWhen={EventTipsList.length}
                  />
                  {/* )} */}
                  {Loading ? (
                    <KendoLoader className="d-flex justify-content-end align-items-center" />
                  ) : (
                    <div className="text-end">
                      <Button
                        name={"Cancel"}
                        isCancelButton={true}
                        id="eventTips-cancel"
                        dataBsDismiss={"modal"}
                        onClick={() => {
                          clearForm();
                        }}
                      />
                      <Button name={"Save"} />
                    </div>
                  )}
                  <button
                    type="button"
                    id="hide"
                    style={{ display: "none" }}
                    data-bs-dismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  ></button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* update */}

        <div
          className="modal custom-modal fade"
          id="update_EventTips"
          role="dialog"
          ref={modalRef}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div
            className="modal-dialog modal-dialog-centered eventTips"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">{title}-Edit</h5>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearForm}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form id="update-form" onSubmit={onUpdate}>
                  <input
                    type="hidden"
                    name="eventTipsID"
                    value={UpdateEventTips.EventTipsID || 0}
                  />
                  <input
                    type="hidden"
                    name="displayedInID"
                    value={UpdateEventTips.DisplayedInID || 0}
                  />
                  <div className="row align-items-end">
                    <div className="col-12">
                      <label className="form-label">
                        Title <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Title with a maximum length of 50 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={50}
                        className="form-control"
                        name="Title"
                        value={UpdateEventTips.Title || ""}
                        placeholder="Title Name"
                        data-required="true"
                        onChange={(e) => {
                          SetUpdateEventTips((prev) => ({
                            ...prev,
                            Title: e.target.value,
                          }));
                          onValidation("Title", e.target.value);
                        }}
                      />

                      <CommonErrorMsg
                        text="Title Name is required"
                        IsError={error.Title}
                      />
                    </div>

                    <div className="col-12">
                      <div className="input-block">
                        <label className="form-label">
                          Description<span className="text-danger">*</span>
                          <InfoIcon content="Please provide a Description with a maximum length of 300 characters." />
                        </label>
                        <textarea
                          maxLength={300}
                          className="form-control field"
                          name="Description"
                          value={UpdateEventTips.Description || ""}
                          placeholder="Description"
                          data-required="true"
                          onChange={(e) => {
                            SetUpdateEventTips((prev) => ({
                              ...prev,
                              Description: e.target.value,
                            }));
                            onValidation("Description", e.target.value);
                          }}
                        />
                        <CommonErrorMsg
                          text={
                            error.Description
                              ? "Description is required"
                              : "Please add at least one Event Tips"
                          }
                          IsError={error.Description || error.EmptyList}
                        />
                      </div>
                    </div>
                    {Loading ? (
                      <KendoLoader className="d-flex justify-content-end align-items-center" />
                    ) : (
                      <div className="text-end">
                        <Button
                          name={"Cancel"}
                          isCancelButton={true}
                          id="eventTips-cancel"
                          dataBsDismiss={"modal"}
                          onClick={() => {
                            clearForm();
                          }}
                        />
                        <Button name={"Update"} />
                      </div>
                    )}
                    <button
                      type="button"
                      id="hide"
                      style={{ display: "none" }}
                      data-bs-dismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    ></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
